const REFRESH_EMAIL_SUCCESS = 'app/auth/email/refresh/success';
const REFRESH_EMAIL_FAIL = 'app/auth/email/refresh/fail';

const LOGIN_EMAIL_SUCCESS = 'app/auth/email/login/success';
const LOGIN_EMAIL_FAIL = 'app/auth/email/login/fail';

export {
    REFRESH_EMAIL_SUCCESS, REFRESH_EMAIL_FAIL, LOGIN_EMAIL_SUCCESS, LOGIN_EMAIL_FAIL,
};
